import { Line } from "../../../Line";
import { Heading } from "../../../typography/Heading";
import { Label } from "../../../typography/Label";
import { useMessage } from "../Context";
import type { QuickRequest } from "../types";

export function QuickRequestCard() {
    const { quickRequest } = useMessage();

    if (!quickRequest) {
        return null;
    }

    return (
        <div className="flex w-full flex-col items-start gap-12">
            <div className="flex w-full flex-col items-start gap-8">
                <Heading level={5}>{quickRequest.title}</Heading>

                {quickRequest.subtitle && (
                    <Heading level={6}>{quickRequest.subtitle}</Heading>
                )}
            </div>

            <QuestionAnswerPairs pairs={quickRequest.questionAnswerPairs} />
        </div>
    );
}

function QuestionAnswerPairs({
    pairs,
}: {
    pairs: QuickRequest["questionAnswerPairs"];
}) {
    if (!pairs?.length) {
        return null;
    }

    return (
        <>
            <Line variant="dashed" />

            {pairs.map((pair) => (
                <div
                    key={pair.question}
                    className="flex w-full flex-col items-start gap-4"
                >
                    <Label size="small" weight="medium-bold">
                        {pair.question}
                    </Label>

                    <Label size="small" weight="regular" color="secondary">
                        {pair.answer}
                    </Label>
                </div>
            ))}
        </>
    );
}
